// ── API Version ──
export const API_VERSION = 'v1';
// ── Client Version ──
// Bump MINOR for new features, MAJOR for breaking changes.
// When bumping MAJOR, also update MIN_CLIENT_VERSION on the API server.
export const CLIENT_VERSION = '1.0.0';
export const PLAN_LIMITS = {
    starter: { maxProjects: 3, maxKeysPerProject: 500, maxLocalesPerProject: 3 },
    pro: { maxProjects: 15, maxKeysPerProject: 2500, maxLocalesPerProject: 15 },
};
